import { ADDED_DATE_LABEL } from "../../../utils/constants";

// Column model for the Users List table: order, labels and which columns sort.
// Widths are NOT here — users-list-bwai.css sizes each heading cell and its row
// cell from one rule, keyed by the column's `key`.
export const USERS_COLUMNS = [
  { key: "name", label: "Name", sortable: true },
  { key: "email", label: "Email", sortable: true },
  { key: "mobileNumber", label: "Mobile Number", sortable: true },
  { key: "addedDate", label: ADDED_DATE_LABEL, sortable: true },
  { key: "role", label: "Role", sortable: true },
  { key: "actions", label: "", sortable: false },
];
